import {createUseStyles} from 'react-jss'

export default createUseStyles({
  container: {
    margin: '00px 0',
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: 900,
  },
  roomHeader: {
    height: 240,
    width: '100%',
    borderRadius: 10,
    backgroundColor: '#004f9f',
    color: 'white !important',
    padding: '30px 30px 3px 30px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginBottom: 30
  },
  htop: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    '& h1': {
      marginRight: 20,
      color: 'white',

    },
    '& h3': {
      display: 'flex',
      color: 'white',
    },
    '& h3 span': {
      fontSize: 15,
      paddingBottom: 15,
      marginRight: 10,
      fontWeight: '300',
      display: 'flex',
      alignItems: 'center'
    }
  },
  dots: {
    width: 30,
    height: 30,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    cursor: 'pointer',
    
    position: 'relative',
    
    
  },
 
  hbot: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      height: '60px',
      width:'100%',
      position:'relative',
      '& a': {
        display: 'flex',
        alignItems:'center',
        color: 'white',
        
        padding: '0 20px',
        cursor: 'pointer',
        height:'100%',
        position: 'relative',

        
      },
  },
  subpageA: {
    '&.selected': {
      backgroundColor: '#003973'
    }
  },
  selection: {
    position: 'absolute',
    height: 3,
    width: '100%',
    backgroundColor:'white',
    bottom: 0,
    left: 0
  },
  info: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between'
  },
  infoCard: {
    width: 'calc(50% - 20px)',
    backgroundColor: 'white',
    borderRadius: 10,
    overflow: 'hidden',
    border: '1px solid rgba(0,0,0,0.3)',
    flexGrow: 0,
    alignSelf: 'baseline',
    position: "relative"
  },
  ibody: {
    padding: '20px',
  },
  ihead: {
    backgroundColor: 'rgba(0,0,0,0.1)',
    height: 50,
    display: 'flex',
    padding: '3px 20px',
    alignItems: 'center',
    fontWeight: 'bold',
    borderBottom: '1px solid rgba(0,0,0,0.3)'
  },

  members: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column'
  },

  member: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '5px 0'
  },

  voting: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent:'space-between',
    flexWrap: 'wrap'
  },
  pokerContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
  },

  voteResultCards: {
    width: '100%',
    display: 'flex',
    marginTop: 10,
    flexWrap: 'wrap'
  },
  voteResultCard: {
    padding: 10,
    display: 'flex',
    justifyContent: 'space-between',
    border: '1px solid rgba(0,0,0,0.5)',
    borderRadius: 5,
    marginRight: 10,
    marginBottom: 10,
    '& span': {
      margin: '0 5px'
    }
  },

  membersContainer: {
    display: 'flex',
    flexDirection: 'column'
  },

  memberCard: {
    width: '100%',
    display: 'flex',
    padding: 20,
    paddingBottom: 10,
    border: '1px solid rgba(0,0,0,0.5)',
    borderRadius: 10,
    marginBottom: 20,
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  },

  memberImage: {
    width: 50,
    height: 50,
    border: '1px solid rgba(0,0,0,0.5)',
    borderRadius: '50%',
    display: 'flex',
    justifyContent:'center',
    alignItems: 'center',
    fontSize: 25,
    marginRight: 30,
    overflow: 'hidden',
    '& img': {
      width: "150%",
      height: '150%'
    }
  },
  btnReload: {
    backgroundColor: "#038cfc"
  },
  btnBlock: {
    backgroundColor: '#d15241'
  },
  btmClose: {
    backgroundColor: "#ff752b"
  },

  memberL: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 10
  },
  memberR: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },

  memberBtn: {
    margin: '0 10px',
    width: 35,
    height: 35
  },

  pokerCard: {
    border: '2px solid rgba(0,0,0,0.5)',
    height: 100,
    width: 80,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 30,
    cursor: 'pointer',
    position: 'relative',
    borderRadius: 5,
    transition: '0.2s',
    margin: '20px',
    '&:hover': {
      border: '2px solid #004f9f',
    },
    '&.selected': {
      border: '2px solid #004f9f',
      boxShadow: '0 0px 5px #004f9f',
    }
  },
  vrow: {
    '& span': {
      fontSize: 20,
      fontWeight: 'bold',
    }
  },

  vcards: {
    display: 'flex',
    width: '100%',
    marginTop: 20
  },

  vcard: {
    border: '1px solid rgba(0,0,0,0.5)',
    height: 100,
    width: 80,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 30,
    cursor: 'pointer',
    borderLeft: 'none',
    backgroundColor: 'white',
    position: 'relative',
    '&:nth-child(1)': {
      borderLeft: '1px solid rgba(0,0,0,0.5)',
    },
    '&.selected::after': {
      content: '""',
      position: 'absolute',
      width: '100%',
      height: '100%',
      border: '2px solid #004f9f',
      zIndex: 50
    }
  },
  btna: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    marginTop: 30
  },
  votebtn: {
    maxWidth: 300,
  },


  chart: {
    height: 300,
    width: '100%'
  },

  loading: {
    height: 50,
    marginBottom: 10,
    fontSize: 10,
  },
  roomCode: {
    fontSize: 25,
    letterSpacing: 2,
    fontFamily: 'verdana'
  },

  coffeeBreakOption: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    '& span': {
      marginRight: 10
    }
  },

  '@media screen and (max-width: 860px)': {
    vrow: {
      width: '100%',
      '&:nth-child(2)': {
        marginTop: 20
      }
    }
  
  },

  '@media screen and (max-width: 768px)': {
    infoCard: {
      width: '100%',
      margin: '20px 0'
    },
    roomHeader: {
    },
  
  },

  '@media screen and (max-width: 400px)': {
    infoCard: {
      width: '100%',
    },
    roomHeader: {
      padding: '30px 10px 3px 10px'
    },
    htop: {
      padding: '0 10px',
   
    },
    hbot: {
      height: 45,
      justifyContent: 'center',
      '& a': {
        fontSize: 13,
        padding: '0 15px'
      }
    }
  }
})